import type { Clip, ClipSource } from '~/types/pipeline';

function referencePatchEqual(a: Clip['patch'] | null, b: Clip['patch'] | null): boolean {
  if (a === b) return true;
  if (!a || !b) return false;
  return a.frameIndex === b.frameIndex && a.x === b.x && a.y === b.y && a.radius === b.radius;
}

function sourceEqual(a: ClipSource, b: ClipSource): boolean {
  if (a.kind !== b.kind) return false;
  if (a.kind === 'cells' && b.kind === 'cells') {
    if (a.cells.length !== b.cells.length) return false;
    for (let i = 0; i < a.cells.length; i++) {
      const x = a.cells[i];
      const y = b.cells[i];
      if (!x || !y) return false;
      if (x.row !== y.row || x.col !== y.col) return false;
    }
    return true;
  }
  if (a.kind === 'blobs' && b.kind === 'blobs') {
    if (a.blobs.length !== b.blobs.length) return false;
    for (let i = 0; i < a.blobs.length; i++) {
      if (a.blobs[i] !== b.blobs[i]) return false;
    }
    return true;
  }
  return false;
}

export function clipsEqual(a: readonly Clip[], b: readonly Clip[]): boolean {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    const aClip = a[i];
    const bClip = b[i];
    if (!aClip || !bClip) return false;
    if (
      aClip.id !== bClip.id ||
      aClip.name !== bClip.name ||
      aClip.fps !== bClip.fps ||
      aClip.alignmentMode !== bClip.alignmentMode ||
      !referencePatchEqual(aClip.patch, bClip.patch) ||
      !sourceEqual(aClip.source, bClip.source)
    ) {
      return false;
    }
  }
  return true;
}
